<template>
  <div class="container-fluid">
    <!-- MAKE REQUEST -->
    <div
      v-show="
        requestStatus === 'No request made' ||
          requestStatus === 'pending' ||
          requestStatus === 'rejected'
      "
    >
      <div class="make-request">
        <div
          class="request-status"
          v-if="requestStatus === 'pending' || requestStatus === 'rejected'"
        >
          <p>
            Request {{ requestStatus === "pending" ? "pending" : "rejected" }}
          </p>
        </div>
        <div class="access-lock">
          <i class="fa fa-lock fa-4x dark-icon" aria-hidden="true"></i>
        </div>

        <div class="make-request">
          <p class="pending-info" v-if="requestStatus === 'pending'">
            Please wait while your request is been reviewed
          </p>
          <p class="pending-rejected" v-if="requestStatus === 'rejected'">
            Please
            <a
              href="https://arnergy.com/contacts"
              target="_blank"
              rel="noopener noreferrer"
              style="text-decoration: underline; color: darkred;"
              >click
            </a>
            to contact us
          </p>
          <button
            :disabled="
              requestStatus === 'pending' || requestStatus === 'rejected'
            "
            class="btn btn-primary"
            type="button"
            @click="makeRequest"
          >
            Make Request
          </button>
        </div>
      </div>
    </div>
    <!-- After Request API ACCESS KEY -->
    <div v-show="requestStatus === 'accepted'" class="access-box">
      <div class="header-comp">
        <div>
          <h3
            style="font-size: 19px; color: #939daa; font-weight: bold; margin-bottom: 0;"
          >
            API ACCESS
          </h3>
        </div>
        <!-- All the Top buttons will come here -->
        <div class="enable-disable-button">
          <div v-show="isAPIActive" class="all-top-buttons">
            <!-- Regenerate API KEY -->
            <button @click="generateAPIKey" class="btn btn-primary">
              Create API key
            </button>
            <!-- API DOCS -->
            <button @click="navToDoc" class="btn btn-primary">
              API docs
            </button>
          </div>
          <button
            v-show="!isAPIActive"
            @click.stop="navTo('partner-payment')"
            class="btn btn-primary"
            style="margin-right: 14px;"
          >
            Usage & Billing
          </button>
          <button @click="enableDisableBbutton" class="btn btn-primary">
            {{ this.buttonText }}
          </button>
        </div>
      </div>
      <!-- Load state if false -->
      <div>
        <!-- API Enabler -->
        <div v-if="loading === false" v-show="!isAPIActive" class="enable-api">
          <i class="fa fa-info-circle fa-2x" aria-hidden="true"></i>
          <p>
            Please enable API usage to generate API key
          </p>
        </div>

        <!-- GENERATE API Key -->
        <div v-if="loading === false" v-show="isAPIActive" class="viewAPITable">
          <vue-good-table
            :lineNumbers="true"
            :columns="fields"
            :rows="getAPIKeyData"
            :pagination-options="{ enabled: true }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'api_key'">
                {{ maskValue(props.row.api_key) }}
              </span>

              <span v-if="props.column.field == 'created_at'">
                {{ formatDate(props.row.created_at) }}
              </span>
            </template>

            <template slot="pagination-bottom" slot-scope="props">
              <grey-pagination
                :total="props.total"
                :pageChanged="props.pageChanged"
                :perPageChanged="props.perPageChanged"
                @paginated-info="paginationInfo = $event"
              ></grey-pagination>
            </template>
          </vue-good-table>
        </div>
        <div v-else="loading === true">
          <AnimatedSpinnerLoader />
        </div>
      </div>
    </div>

    <!-- The Modal Template -->
    <modal
      width="35%"
      height="auto"
      name="access-modal"
      style="border-radius: 28px !important"
      class="first-modal"
    >
      <div class="row api-key-modal">
        <!-- Show API-KEY -->
        <div class="col-sm-12 col-md-12 col-lg-12">
          <p class="flex-content">
            <span class="flex-left"><p>Copy your new API key</p></span>
            <span @click="copyText(api_key)" class="flex-right"
              ><p class="api-copy-icon">
                <i class="fa fa-clipboard" aria-hidden="true"></i> Copy
              </p></span
            >
          </p>
          <p class="api-key">{{ api_key }}</p>
        </div>
        <!-- Close Modal -->
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-primary button-style"
            @click="hide"
          >
            I've saved the API key to a safe place
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Noty from "noty";
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";
import moment from "moment";
import { get } from "js-cookie";

export default {
  name: "AccessKey",
  components: { AnimatedSpinnerLoader },
  data() {
    return {
      buttonText: "Enable API Usage",
      // makeARequest: true,
      api_key: "API Key is placed here....",
      enableGenerator: true,
      loading: false,
      isAPIActive: false,
      requestStatus: "",
      // requestStatus: "accepted",
      // isAPIActive: true,
      getAllAPi: [],
      fields: [
        {
          field: "api_key",
          label: "API_Key",
          sortable: "true"
        },
        {
          field: "created_at",
          label: "Create At",
          sortable: "true"
        }
      ]
    };
  },
  computed: {
    getAPIKeyData: {
      get() {
        return this.getAllAPi;
      }
    }
  },
  methods: {
    navTo(url) {
      this.$router.push({
        name: url
      });
    },
    maskValue(value) {
      const start = value.substring(0, 3);
      const end = value.substring(value.length - 3);
      return `${start}******************${end}`;
    },
    copyText(text) {
      if (text) {
        this.showToast("Key copied");
        navigator.clipboard.writeText(text);
      }
    },
    show() {
      this.$modal.show("access-modal");
    },
    hide() {
      this.$modal.hide("access-modal");
    },
    showToast(text, type = "success") {
      new Noty({
        theme: "bootstrap-v3",
        text: text,
        type,
        timeout: 1000
      }).show();
    },
    async enableDisableBbutton() {
      if (this.buttonText === "Enable API Usage") {
        this.updateAPIStatus("activate");
      } else {
        this.updateAPIStatus("deactivate");
      }
    },
    async generateAPIKey() {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType"),
        "x-partner-id": localStorage.getItem("uuid"),
        "x-user-id": localStorage.getItem("userToken")
      };

      HTTP.post(
        `/partners/${localStorage.getItem("uuid")}/generate-api-key`,
        {},
        { headers }
      )
        .then(res => {
          this.api_key = res.data.api_key;
          this.loading = false;
          this.checkPartnerStatus();
          this.show();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    async updateAPIStatus(status) {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType"),
        "x-partner-id": localStorage.getItem("uuid"),
        "x-user-id": localStorage.getItem("userToken")
      };

      HTTP.post(
        `/partners/${localStorage.getItem("uuid")}/${status}`,
        {},
        { headers }
      )
        .then(res => {
          this.checkPartnerStatus();
          this.showToast(res.data.message);
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    async checkPartnerStatus() {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };

      HTTP.get(`/partners/${localStorage.getItem("uuid")}/access-status`, {
        headers
      })
        .then(res => {
          this.requestStatus = res.data.status;
          this.isAPIActive = res.data.is_active || false;
          this.getAllAPi = [res.data.api_access];
          this.buttonText = res.data.is_active
            ? "Disable API Usage"
            : "Enable API Usage";
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    navToDoc() {
      window.open(
        "https://documenter.getpostman.com/view/32251532/2sA3dyhAfH#8f147834-6b55-4860-841f-88abd05bc65d",
        "_blank"
      );
    },
    async makeRequest() {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };
      const payload = {
        partner_id: localStorage.getItem("uuid"),
        status: "pending"
      };
      HTTP.post(`/partners/request-access`, payload, { headers })
        .then(res => {
          this.showToast("Access Request sent");
          this.checkPartnerStatus();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  async mounted() {
    await this.checkPartnerStatus();
  },
  async updated() {
    if (this.requestStatus === "rejected" || this.requestStatus === "pending") {
      setInterval(() => {
        this.checkPartnerStatus();
      }, 60000);
    }
  }
};
</script>

<style lang="scss" scoped>
.container-fluid {
  background-color: #f8f8f8;
}
.pending-info {
  position: absolute;
  top: 90%;
  text-align: center;
  left: 22%;
}
.pending-rejected {
  position: absolute;
  top: 90%;
  text-align: center;
  left: 51%;
  transform: translate(-50%, -50%);
  color: red;
}
.make-request {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 0px 3px rgba(65, 65, 65, 0.16);
  border-radius: 1.4rem;
  width: 550px;
  height: 400px;
  border: 2px solid whitesmoke;
}
.request-status p {
  color: green;
  text-align: right;
  margin: 12px 24px;
  font-size: 16px;
  font-weight: 700;
}
.access-lock {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dark-icon {
  color: #000000;
}
.make-request button {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.enable-api {
  width: 48%;
  height: 210px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 123px;
  border: 1px solid #939daa;
  border-radius: 3.4em;
  box-shadow: 4px 4px #939daa;

  i {
    margin-top: 45px;
    margin-left: 48%;
    margin-right: auto;
  }
  p {
    margin-top: 50px;
    text-align: center;
  }
}

.button-style {
  width: 100%;
  border-radius: 8px;
}

.api-copy-icon {
  display: flex;
  align-items: center;
  gap: 1px;
  border: 1px solid #000;
  margin-left: 70%;
  text-align: center;
  border-radius: 6px;
  padding: 5px 2px;
}

.flex-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-left {
  flex: 1;
  text-align: left;
  font-size: 16px;
}

.flex-right {
  flex: 1;
  text-align: right;
  cursor: pointer;
}

.button-close {
  padding: 10px;
  border-radius: 6px;
  border: none;
  width: 200px;
  background: red;
  color: white;
  font-weight: 700;
}

.api-key {
  margin: 4px 0;
  border: 1px solid grey;
  border-radius: 5px;
  padding: 8px 0;
  cursor: pointer;
}

.modal-info {
  font-weight: 600;
  color: #337ab7;
}

.generate-api {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  height: 50%;
  border: 1px solid gray;
  border-radius: 3.4em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  .copy-key-token {
    border-bottom: 1px solid black;
    min-width: 30%;
  }
}
.enable-disable-button {
  display: flex;
  justify-content: flex-end;
}

.header-comp {
  border-bottom: 1px solid #939daa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0;
}

.api-key-modal {
  padding: 20px;
  box-shadow: 1px 1px 5px 10px grey;
  border-radius: 8px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  // gap: 12px;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.viewAPITable {
  margin-top: 12px;
}
.all-top-buttons {
  margin-right: 12px;
  button {
    margin-left: 12px;
  }
}
.content-area {
  background-color: #f5f6f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/section-manager/AccessKey.vue